function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useEffect, useState } from 'react';
import { Button, Divider, Space, Drawer, message, Skeleton, Modal, Table } from 'antd';
import { Container, Row, Col } from 'react-bootstrap';
import { FuelPumpFill, GearFill } from 'react-bootstrap-icons';
import AddStation from '../components/forms/AddStation';
import Common from '../components/includes/Common';
import StationView from '../components/StationView';
import AddConfiguration from '../components/forms/AddConfiguration';
import ConfigurationListView from '../components/ConfigurationListView';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Organisation = function Organisation() {
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    isNewGsOpen = _useState2[0],
    setIsNewGsOpen = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isStationViewVisible = _useState4[0],
    setIsStationViewVisible = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isNewConfigurationVisible = _useState6[0],
    setIsNewConfigurationVisible = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    stationsList = _useState8[0],
    setStationsList = _useState8[1];
  var _useState9 = useState(true),
    _useState10 = _slicedToArray(_useState9, 2),
    isDataLoading = _useState10[0],
    setIsDataLoading = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    isDataChanged = _useState12[0],
    setIsDataChanged = _useState12[1];
  var _useState13 = useState(null),
    _useState14 = _slicedToArray(_useState13, 2),
    selectedStation = _useState14[0],
    setSelectedStation = _useState14[1];
  var _useState15 = useState([]),
    _useState16 = _slicedToArray(_useState15, 2),
    configurationList = _useState16[0],
    setConfigurationList = _useState16[1];
  var handleViewStationClick = function handleViewStationClick(s) {
    setSelectedStation(s);
    setIsStationViewVisible(true);
  };
  var scols = [{
    title: 'Station',
    key: 'label',
    dataIndex: 'label',
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text
      });
    }
  }, {
    title: '',
    key: 'action',
    dataIndex: 'action',
    render: function render(s) {
      return /*#__PURE__*/_jsx(_Fragment, {
        children: /*#__PURE__*/_jsx(Button, {
          type: "default",
          onClick: function onClick() {
            handleViewStationClick(s);
          },
          children: /*#__PURE__*/_jsx("b", {
            children: "GERER"
          })
        })
      });
    }
  }];
  useEffect(function () {
    setIsDataChanged(false);
    axios.all([axios.get(Common.baseApiUrl + 'getautorizedstations/' + Common.currentUser.id), axios.get(Common.baseApiUrl + 'getconfigurations/' + Common.currentUser.id)]).then(function (response) {
      setIsDataLoading(true);
      if (response[0].data.status == 200) {
        setStationsList([]);
        response[0].data.stations.forEach(function (s) {
          setStationsList(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              label: s.label,
              action: s
            }]);
          });
        });
      } else {
        message.error({
          content: response[0].data.message,
          delay: 4
        });
      }
      setConfigurationList([]);
      if (response[1].data.status == 200) {
        setConfigurationList(response[1].data.configurations);
      }
    })["catch"](function (error) {
      message.error({
        content: 'Une erreur est survenue',
        delay: 4
      });
    })["finally"](function () {
      setIsDataLoading(false);
    });
  }, [isDataChanged]);
  return /*#__PURE__*/_jsxs(Container, {
    children: [/*#__PURE__*/_jsx(Row, {
      children: /*#__PURE__*/_jsxs(Col, {
        lg: 12,
        md: 12,
        sm: 12,
        children: [/*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsxs(Space, {
            direction: "horizontal",
            wrap: true,
            children: [/*#__PURE__*/_jsx(Button, {
              type: "link",
              onClick: function onClick() {
                setIsNewGsOpen(true);
              },
              children: /*#__PURE__*/_jsxs("b", {
                children: [/*#__PURE__*/_jsx(FuelPumpFill, {
                  size: 16
                }), " NOUVELLE STATION"]
              })
            }), /*#__PURE__*/_jsx(Button, {
              type: "link",
              onClick: function onClick() {
                setIsNewConfigurationVisible(true);
              },
              children: /*#__PURE__*/_jsxs("b", {
                children: [/*#__PURE__*/_jsx(GearFill, {
                  size: 16
                }), " NOUVELLE TARIFICATION"]
              })
            })]
          })
        }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Table, {
          bordered: true,
          size: "small",
          columns: scols,
          dataSource: stationsList
        }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(ConfigurationListView, {
          configurationList: configurationList,
          dataRefresh: function dataRefresh() {
            setIsDataChanged(true);
          }
        })]
      })
    }), /*#__PURE__*/_jsx(Drawer, {
      title: /*#__PURE__*/_jsx("b", {
        children: "AJOUTER UNE STATION"
      }),
      width: "320px",
      open: isNewGsOpen,
      onClose: function onClose() {
        setIsNewGsOpen(false);
      },
      destroyOnClose: true,
      children: /*#__PURE__*/_jsx(AddStation, {
        handler: function handler() {
          setIsNewGsOpen(false);
          setIsDataChanged(true);
          message.success({
            content: 'Opération réussie !',
            delay: 4
          });
          window.location.reload();
        }
      })
    }), selectedStation != null && /*#__PURE__*/_jsx(Modal, {
      title: /*#__PURE__*/_jsx("b", {
        children: selectedStation.label
      }),
      open: isStationViewVisible,
      onCancel: function onCancel() {
        setIsStationViewVisible(false);
      },
      destroyOnClose: true,
      footer: null,
      width: "85%",
      children: /*#__PURE__*/_jsx(StationView, {
        station: selectedStation
      })
    }), /*#__PURE__*/_jsx(Drawer, {
      title: /*#__PURE__*/_jsx("b", {
        children: "NVLLE CONFIGURATION"
      }),
      open: isNewConfigurationVisible,
      onClose: function onClose() {
        setIsNewConfigurationVisible(false);
      },
      destroyOnClose: true,
      width: "280",
      children: /*#__PURE__*/_jsx(AddConfiguration, {
        handler: function handler() {
          setIsDataChanged(true);
          setIsNewConfigurationVisible(false);
          message.success({
            content: 'Opération réussie !'
          });
        }
      })
    })]
  });
};
export default Organisation;